export enum WeekDaysEnum {
  MONDAY = 'Måndag',
  TUESDAY = 'Tisdag',
  WEDNESDAY = 'Onsdag',
  THURSDAY = 'Torsdag',
  FRIDAY = 'Fredag',
  SATURDAY = 'Lördag',
  SUNDAY = 'Söndag',
}

export enum WeekDaysEnglishEnum {
  MONDAY = 'Monday',
  TUESDAY = 'Tuesday',
  WEDNESDAY = 'Wednesday',
  THURSDAY = 'Thursday',
  FRIDAY = 'Friday',
  SATURDAY = 'Saturday',
  SUNDAY = 'Sunday',
}

export enum WeekDayIndexesEnum {
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
  SUNDAY = 7,
}
